// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientsPopup_modal__22EXc","container":"PatientsPopup_container__2ZuOm"};